import { findMaxReducer } from '../../utils'

const countries = require('../../assets/countries')

export const listOrderComparator = (one, two) => {
  return one.order - two.order
}

export const findMaxOrderReducer = findMaxReducer(item => item.order)

export const getSampleFieldsValue = fields => {
  const sampleAttendee = {}
  for (const field of Object.keys(fields)) {
    sampleAttendee[field] = field
  }

  return sampleAttendee
}

export const listToFieldsReducer = (acc, item, index) => {
  const { name, ...rest } = item
  acc[name] = {
    ...rest,
    order: index + 1,
  }

  return acc
}

export const ATTENDEE_FIELDS_OPTIONS = [
  {
    display: 'Description Label',
    value: {
      fieldID: 'description-label',
      component: 'rich-text-description-label',
      type: 'rich-text-editor',
      hideRequired: true,
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Time',
    value: {
      fieldID: 'time',
      component: 'time-field',
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Date',
    value: {
      fieldID: 'date',
      component: 'date-field',
      type: 'date',
      validations: {
        date: true,
        required: false,
      },
    },
  },
  {
    display: 'Section label',
    value: {
      fieldID: 'section-label',
      component: 'form-section-label',
      hideRequired: true,
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Text',
    value: {
      fieldID: 'text',
      component: 'text-field',
      type: 'text',
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Email',
    value: {
      fieldID: 'email',
      component: 'text-field',
      type: 'email',
      validations: {
        required: false,
        email: true,
      },
    },
  },
  {
    display: 'Number',
    value: {
      fieldID: 'number',
      component: 'text-field',
      type: 'number',
      validations: {
        required: false,
        numeric: true,
      },
    },
  },
  {
    display: 'Dropdown',
    value: {
      multiselect: false,
      fieldID: 'select',
      component: 'select-field',
      type: 'dropdown',
      items: [''],
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Checkbox',
    value: {
      fieldID: 'checkbox',
      component: 'checkbox-group',
      type: 'checkbox',
      items: [''],
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Consent',
    value: {
      fieldID: 'consent',
      component: 'switch-field',
      item: '',
      type: 'consent',
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Radio button',
    value: {
      fieldID: 'radio-button',
      component: 'radio-button',
      type: 'radio-button',
      items: [''],
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Text area',
    value: {
      fieldID: 'text-area',
      component: 'textarea-field',
      type: 'text',
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Avatar photo',
    value: {
      fieldID: 'avatar-field',
      component: 'avatar-field',
      type: 'avatar-field',
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Country',
    value: {
      fieldID: 'country',
      component: 'autocomplete-field',
      items: countries,
      itemRender: 'common',
      itemSelect: 'iso2',
      type: 'country',
      validations: {
        required: false,
      },
    },
  },
  {
    display: 'Phone number',
    value: {
      fieldID: 'phone-number',
      component: 'phone-number-field',
      type: 'phone-number',
      validations: {
        required: false,
      },
    },
  },
]
